/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Technology from './pages/Technology';
import Factory from './pages/Factory';
import Contact from './pages/Contact';
import RoiCalculator from './pages/RoiCalculator';
import Blog from './pages/Blog';

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/factory" element={<Factory />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/roi-calculator" element={<RoiCalculator />} />
          <Route path="/blog" element={<Blog />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
